<template>
    <div class="fonts-list">
        <div class="row">
            <div class="col-md-1">
                <strong>{{ t_filename }}</strong>
            </div>
            <div class="col-md-2">
                <strong>{{ t_family }}</strong>
            </div>
            <div class="col-md-1">
                <strong>{{ t_weight }}</strong>
            </div>
            <div class="col-md-2">
                <strong>{{ t_style }}</strong>
            </div>
            <div class="col-md-1">
                <strong>{{ t_family_on_device }}</strong>
            </div>
            <div class="col-md-2">
                <strong>{{ t_example }}</strong>
            </div>
            <div class="col-md-1" v-if="superadmin">
                <strong>{{ t_packet }}</strong>
            </div>
            <div :class="superadmin ? 'col-md-1' : 'col-md-2'">
                <strong>{{ t_added }}</strong>
            </div>
            <div class="col-md-1"></div>
        </div>
        <template v-for="(font,key) in inner_fonts">
            <div class="row font-row" :class="[fonts_errors[key] ? 'has-error' : '', fonts_deleted[key] ? 'deleted' : '']">
                <div class="col-md-1 mt-auto mb-auto overflow-ellipsis">
                    <span>{{ inner_fonts[key].file_name }}</span>
                </div>
                <div class="col-md-2">
                    <v-text-field :aria-label="'font-family ' + inner_fonts[key].family" type="input" v-model="inner_fonts[key].family" :disabled="fonts_deleted[key]"
                                  :outlined="true" :dense="true" hide-details="auto"></v-text-field>
                </div>
                <div class="col-md-1">
                    <v-select-custom
                        :aria-label="'font-weight ' + inner_fonts[key].weight"
                        v-model="inner_fonts[key].weight"
                        :disabled="fonts_deleted[key]"
                        :items="[
                            { value: 'normal', text: t_normal },
                            { value: 'bold', text: t_bold },
                        ]"
                    />
                </div>
                <div class="col-md-2">
                    <v-select-custom
                        :aria-label="'font-style ' + inner_fonts[key].style"
                        v-model="inner_fonts[key].style"
                        :disabled="fonts_deleted[key]"
                        :items="[
                            { value: 'normal', text: t_normal },
                            { value: 'italic', text: t_italic },
                        ]"
                    />
                </div>
                <div class="col-md-1">
                    <v-text-field :aria-label="'family on device ' + inner_fonts[key].family_on_device" type="input" v-model="inner_fonts[key].family_on_device" :disabled="fonts_deleted[key]"
                                  :outlined="true" :dense="true" hide-details="auto"></v-text-field>
                </div>
                <div class="col-md-2 mt-auto mb-auto overflow-ellipsis"
                     :style="{
                        fontFamily: '\'' + fonts[key]['family'] + '\'',
                        fontStyle: fonts[key]['style'],
                        fontWeight: fonts[key]['weight']
                    }">
                    <span>The quick brown fox jumps over the lazy dog.</span>
                </div>
                <div id="select-font-packet" class="col-md-1" v-if="superadmin">
                    <v-select-custom
                        :aria-label="'Packet ' + inner_fonts[key].packet"
                        v-model="inner_fonts[key].packet"
                        :disabled="fonts_deleted[key]"
                        :items="[
                            { value: null, text: t_custom },
                            { value: 'microsoft', text: t_microsoft },
                            { value: 'google', text: t_google },
                        ]"
                    />
                </div>
                <div :class="superadmin ? 'col-md-1' : 'col-md-2'"
                     class="mt-auto mb-auto overflow-ellipsis">
                    <span>{{ font['created_at'] }}</span>
                </div>
                <div class="col-md-1">
                    <square-button :tooltip-text="t_undo_delete"
                                   aria-label="undo delete"
                                   v-if="fonts_deleted[key]"
                                   class="btn btn-secondary"
                                   flat
                                   icon="fa-regular fa-trash-undo"
                                   @click="undeleteFont(key)" />

                    <square-button :tooltip-text="t_delete"
                                   aria-label="delete"
                                   v-else
                                   class="btn btn-secondary"
                                   flat
                                   icon="fa-regular fa-trash"
                                   @click="deleteFont(key)" />

                    <square-button :tooltip-text="t_download"
                                   aria-label="download"
                                   v-if="inner_fonts[key].file_name"
                                   class="btn btn-secondary"
                                   flat
                                   icon="fa-regular fa-download"
                                   @click="downloadFont(key)" />
                </div>
            </div>
<!--            <div v-if="inner_fonts[key+1] && inner_fonts[key].family !== inner_fonts[key+1].family" class="m-b-lg"></div>-->
        </template>
    </div>
</template>

<script>
    import SquareButton
        from "../../content/common/squareButton.vue";
    import DropdownPopperWrapper from '../../common/dropdown-popper-wrapper.vue';

    export default {
        data: function () {
            return {
                t_added: Lang.langGet("Added at"),
                t_filename: Lang.langGet("File name"),
                t_family: Lang.langGet("Family"),
                t_weight: Lang.langGet("Weight"),
                t_style: Lang.langGet("Style"),
                t_family_on_device: Lang.langGet("Family on Device"),
                t_example: Lang.langGet("Example Text"),
                t_normal: Lang.langGet("Normal"),
                t_bold: Lang.langGet("Bold"),
                t_italic: Lang.langGet("Italic"),
                t_packet: Lang.langGet("Packet"),
                t_custom: Lang.langGet("Custom"),
                t_microsoft: Lang.langGet("Microsoft (preferable in windows clients"),
                t_google: Lang.langGet("Google (preferable on H5-clients)"),
                t_download: Lang.langGet("Download"),
                t_delete: Lang.langGet("Delete"),
                t_undo_delete: Lang.langGet("Undo delete"),

                original_fonts: [],
                inner_fonts: [],
                fonts_errors: [],
                fonts_deleted: [],
            }
        },
        components: {
            DropdownPopperWrapper,
            SquareButton,
        },
        props: [
            'fonts',
            'loading',
            'superadmin'
        ],
        computed: {
        },
        watch: {
            fonts() {
                this.original_fonts = this.fonts;
            },
            original_fonts () {
                let inner_fonts = JSON.parse(JSON.stringify(this.original_fonts));
                _.each(inner_fonts, (font, key) => {
                    this.fonts_deleted[key] = false;
                });
                this.inner_fonts = inner_fonts;
                this.check_fonts();
                this.edited = false;
            },
            inner_fonts: {
                handler () {
                    this.check_fonts();
                },
                deep: true
            }
        },
        methods: {
            check_fonts(key=null) {
                key = null;
                _.each(this.inner_fonts, (font, key) => {
                    this.fonts_errors[key] = null;
                });

                let keys = [];
                if (key) {
                    keys = [key];
                } else {
                    keys = Object.keys(this.inner_fonts);
                }

                _.each(keys, (key) => {
                    if (this.fonts_deleted[key]) {
                        return true;
                    }
                    let font = this.inner_fonts[key];
                    if (this.fonts_errors[key] === null) {
                        let same_font = this.inner_fonts.findIndex((otherFont, index) => {
                            index = index.toString();
                            if (key === index || this.fonts_deleted[index]) {
                                return false;
                            }
                            return (otherFont.style === font.style && otherFont.weight === font.weight && otherFont.family === font.family);
                        });
                        if (same_font >= 0) {
                            this.fonts_errors[same_font] = true;
                            this.fonts_errors[key] = true;
                        }
                    }
                });
                let edited = JSON.stringify(this.inner_fonts) !== JSON.stringify(this.original_fonts) || this.fonts_deleted.some((deleted) => { return deleted });
                let errors = this.fonts_errors.some((errors) => { return errors === true });
                EaseEventBus.fire('fonts-saveable', edited && !errors);
            },
            deleteFont(key) {
                Vue.set(this.fonts_deleted, key, true);
                Vue.set(this.inner_fonts[key], 'delete', true);
                this.check_fonts(key);
            },
            undeleteFont(key) {
                Vue.set(this.fonts_deleted, key, false);
                Vue.set(this.inner_fonts[key], 'delete', undefined);
                this.check_fonts(key);
            },
            downloadFont(key) {
                axios.get('/administration/font/download/' +
                    Laravel.activeProject + '/' + this.inner_fonts[key].id
                ).then((response) => {
                    const url = '/administration/font/download/' +
                        Laravel.activeProject + '/' + this.inner_fonts[key].id;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'download');
                    document.body.appendChild(link);
                    link.click();
                }).catch((error) => {
                });
            },
            saveFonts(key) {
                axios.post('/administration/font/edit', {
                    id: Laravel.activeProject,
                    fonts: this.inner_fonts,
                }).then((response) => {
                    EaseEventBus.fire('fonts-dave-done');
                    this.original_fonts = response.data.fonts;
                }).catch((error) => {
                    this.loading = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                });
            },
        },
        mounted() {
            this.original_fonts = this.fonts;

            EaseEventBus.listen('fonts-save', () => {
                this.saveFonts();
            })
        }
    }
</script>
